import VueRouter from 'vue-router';
import routes from './routes';
import store from '../store/store';
import * as allTypes from '../store/mutation-type';

const router = new VueRouter({
  mode: 'history',
  routes,
});

router.beforeEach((to, from, next) => {
  ['opportunites'].forEach((module) => {
    store.commit(module + '/' + allTypes.RESET_NOT_PERSISTED);
  });
  next(true);
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js